/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { BorderStyle } from "@mui/icons-material";
import { Theme } from "@mui/material";
import colors from "react-multi-date-picker/plugins/colors";

export const dropzoneStyle = {
  container: {
    gap: "1rem",
  },
  dropzone: (theme: Theme) => ({
    position: "relative",
    alignItems: "center",
    width: "100%",
    padding: "5.5rem 0",
    border: "0.2rem dashed",
    borderColor: "grey.300",
    gap: "1rem",
    borderRadius: theme.shape.borderRadius,
    cursor: "pointer",
    transition: "all 200ms cubic-bezier(0, 0.12, 0.25, 1)",
    "&:hover, &:focus-visible": {
      backgroundColor: "grey.200",
      border: "inerhit",
    },
  }),
  dropzoneDragAccept: {
    borderStyle: "solid",
    borderColor: "primary.main",
  },
  dropzoneDragReject: {
    borderStyle: "solid",
    borderColor: "error.light",
  },
  dropzoneError: {
    borderStyle: "solid",
    borderColor: "error.light",
    color: "error.main",
  },
  icon: { fontSize: "3.5rem" },
  chips: {
    gap: "1rem",
  },
};
